import axios from '@/plugins/axios.js';

const quizWaitingRoomService = {
    async getStatus(attemptId, signal) {
        const response = await axios.get(`/api/quiz-attempts/${attemptId}`, {
            ...(signal ? { signal } : {}),
            timeout: 15000,
            retry: false,
            errorHandle: false,
        });
        return response.data?.data;
    },

    async getActivity({ attemptId, activityId }, signal) {
        const config = { signal, timeout: 15000, retry: false, errorHandle: false };
        let resolvedActivityId = activityId;

        if (attemptId) {
            const response = await axios.get(`/api/quiz-attempts/${attemptId}`, {
                ...config,
                params: { include: 'quizActivity.activity,surveyActivity.activity' },
            });
            const attempt = response.data.data;
            resolvedActivityId = attempt?.quiz_activity?.activity?.id ?? attempt?.survey_activity?.activity?.id;
        }

        if (!resolvedActivityId) throw new Error('The quiz activity is unavailable.');

        const response = await axios.get(`/api/activities/${resolvedActivityId}`, {
            ...config,
            params: { append: 'question_count' },
        });
        const activity = response.data.data;
        if (!activity?.id || !activity.activity_content) throw new Error('The quiz activity is unavailable.');

        return activity;
    },
};

export default quizWaitingRoomService;
